import styles from "./styles.module.scss";
import Section from "../../../components/Section";
import figma_icon from "../../../graphics/figma_icon.svg";
import bank_1 from "../../../images/bank_1.png";
import bank_2 from "../../../images/bank_2.png";
import bank_3 from "../../../images/bank_3.png";
import bank_4 from "../../../images/bank_4.png";
import bank_5 from "../../../images/bank_5.png";
import bank_6 from "../../../images/bank_6.png";

const Bank = () => {
  return (
    <Section>
      <h2 className={styles.title}>
        Банковское приложение с кэшбеками и трекером трат
      </h2>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.item}>
            <h4 className={styles.subtitle}>Бизнес-задача</h4>
            <p className={styles.text}>
              Cоздать интерфейс, который бы продвигал уникальные предложения
              банка и делал его удобным для повседневного использования,
              акцентируя внимание на кэшбеках и управлении финансами.
            </p>
          </div>

          <div className={styles.item}>
            <h4 className={styles.subtitle}>Процесс решения</h4>
            <p className={styles.text}>
              Сфокусировалась на удобстве финансового планирования и легкости
              управления бюджетом. Добавила разделы для отслеживания кэшбеков,
              уведомления о транзакциях и отчеты о расходах, чтобы пользователи
              могли видеть полную картину своих финансов.
            </p>
          </div>
        </div>

        <div className={styles.images}>
          <div className={styles.item}>
            <img src={bank_1} alt="" />
          </div>
          <div className={styles.item}>
            <img src={bank_2} alt="" />
          </div>
          <div className={styles.item}>
            <img src={bank_3} alt="" />
          </div>
          <div className={styles.item}>
            <img src={bank_4} alt="" />
          </div>
          <div className={styles.item}>
            <img src={bank_5} alt="" />
          </div>
          <div className={styles.item}>
            <img src={bank_6} alt="" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Bank;
